import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { AudioTrack } from '../../../asset/utils/AudioTrack';
import { setPlay, setRewind, setTrack, setUnit, setUnitAct } from '../../../store/TrackSlice';
import { Button } from '../../_atoms/Button';

const BtnWrap = styled.div`
  align-self: center;
  justify-self: center;
`;

export const AudioPlayerButton = (props) => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  const onAudioPrev = () => {
    // 첫번째 트랙
    if (state.track.track === 0 && state.track.unit !== 0) {
      dispatch(setUnitAct(state.track.unit_act - 1));
      dispatch(setUnit(state.track.unit - 1));
      dispatch(setTrack(AudioTrack[state.book.current_book][state.track.unit - 1].length - 1));
    } else if (state.track.track > 0) {
      dispatch(setTrack(state.track.track - 1));
    }
  };

  const onAudioNext = () => {
    // 마지막 트랙
    if (state.track.track === AudioTrack[state.book.current_book][state.track.unit].length -1 && state.track.unit !== AudioTrack[state.book.current_book].length - 1) {
      dispatch(setTrack(0));
      dispatch(setUnitAct(state.track.unit_act + 1));
      dispatch(setUnit(state.track.unit + 1));
    } else if (state.track.track < AudioTrack[state.book.current_book][state.track.unit].length -1) {
      dispatch(setTrack(state.track.track + 1));
    }
  };

  return (
    <BtnWrap>
      <Button type="audio" name="prev" page={props.page} onClick={() => onAudioPrev()} />
      <Button type="audio" name="play" page={props.page} onClick={() => {dispatch(setPlay(!state.track.play)); dispatch(setRewind(false))}} className={state.track.play && 'act'}/>
      <Button type="audio" name="next" page={props.page} onClick={() => onAudioNext()}/>
    </BtnWrap>
  );
};